export default __webpack_public_path__ + "static/logo-umber-a06ab3e68944d419f47a13e956e6ae0e.svg";